import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AirKeyWrapper } from '@/wrappers/AirKeyWrapper/AirKeyWrapper';
import { BrowserConfigParser } from '@components/BrowserConfigParser';
import { Template } from '@components/Template/Template';
import { Activation } from '@pages/Activation';
import { AlternativeWorkflow } from '@pages/AlternativeWorkflow';
import { CallCenter } from '@pages/CallCenter';
import { Enrollments } from '@pages/Enrollments';
import { MerchantTransaction } from '@pages/MerchantTransaction';
import { NotFound } from '@pages/NotFound';
import { Sandbox } from '@pages/Sandbox';
import { TestingHarness } from '@pages/TestingHarness';
import { ThreeDS } from '@pages/ThreeDS';
import { isProd } from './utils/isProd';

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        {/* the new hotness */}
        <Route path="/ul" element={<AirKeyWrapper />}>
          <Route index element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
          <Route
            path=":intentOwner/:workflow/:sessionId"
            element={<Template />}
          />
        </Route>

        {/* kept for backwards compatibility */}
        <Route path="/" element={<BrowserConfigParser />}>
          <Route
            path="/3ds/:processId"
            element={
              <ThreeDS
                withWebNfcChecksCancelledMock={
                  import.meta.env.MODE !== 'production'
                }
              />
            }
          />
          <Route path="/ul/sb/auth/:processId" element={<Sandbox />} />
        </Route>

        {!isProd && (
          <Route path="/" element={<BrowserConfigParser />}>
            <Route
              path="/alternative/:processId"
              element={<AlternativeWorkflow />}
            />
            <Route
              path="/merchanttransaction/:processId"
              element={<MerchantTransaction />}
            />
            <Route path="/callcenter/:processId" element={<CallCenter />} />
            <Route path="/enrollments/:processId" element={<Enrollments />} />
            <Route
              path="/activation/:processId"
              element={
                //Display this only in local, dev and qa.
                import.meta.env.MODE !== 'production' ? (
                  <Activation isLoading={false} />
                ) : (
                  <NotFound />
                )
              }
            />

            <Route path="/testingHarness" element={<TestingHarness />} />
          </Route>
        )}
        <Route index element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
